import { APIClient } from "api/api_helper";
import { VOLUNTEER_API, VOLUNTEER_STUDY_DASHBOARD_API } from "api/url_helper";
import {
  CurrentUser,
  GetUserData,
} from "common/service/CommonService";

// ------------------------------------------------------------------
// API CLIENT
// ------------------------------------------------------------------ */

const api = new APIClient();

// ------------------------------------------------------------------
// Volunteer API
// ------------------------------------------------------------------

export const volunteerStudyHistoryApiService = {
  getStudySelectAllData: (
    volunteerid?: number | null,
    status?: string | null,
    searchText?: string | null,
    pageNumber: number = 1,
    pageSize: number = 10,
  ) => {
    const payload = {
      volunteerid: volunteerid,
      status: status || null,
      searchtext: searchText || null,
      currentpage: pageNumber,
      pagesize: pageSize,
    };
    return api.create(VOLUNTEER_API.VOLUNTEER_API + "StudySelectAll", payload);
  },

  deleteVolunteerStudyData: (payload_data: {
    volunteerid: number | null;
    studyid: number | null;
    updatereason: string;
  }) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      volunteerid: payload_data.volunteerid,
      studyid: payload_data.studyid,
      updatereason: payload_data.updatereason,
      updatedby: user.userid,
    };
    return api.create(VOLUNTEER_API.VOLUNTEER_API + "StudyDelete", payload);
  },

  getVolunteerStudyDashboardData: (studyid: number | null, volunteerid: number | null) => {
    const payload = {
      studyid: studyid,
      volunteerid: volunteerid,
    };
    return api.create(VOLUNTEER_STUDY_DASHBOARD_API.VOLUNTEER_STUDY_DASHBOARD_API + "SelectAll", payload);
  },
};
